// extracted by mini-css-extract-plugin
export default {"Gmation":"styles_Gmation__3ltow","BgAnimation__svg":"styles_BgAnimation__svg__i9YaK"};